import { useCallback } from 'react';

import { atlasClient as baseAtlasClient } from '@/client/atlas';

import { useAuth } from './use-auth';

/**
 * Hook that provides an auth-aware Atlas client.
 * This hook uses the auth context to automatically include authentication headers.
 */
export const useAtlasClient = () => {
  const { getAccessToken } = useAuth();

  const atlasClient = useCallback(
    async <TRequest, TResponse>(
      params: Omit<Parameters<typeof baseAtlasClient<TRequest, TResponse>>[0], 'getAccessToken'>
    ) => {
      return baseAtlasClient({
        ...params,
        getAccessToken,
      });
    },
    [getAccessToken]
  );

  return atlasClient;
};
